export default {
    path: 'enterprise_grid/manage_employees',
    name: 'BuyerEmployeesGrid',
    meta: {
      enterpriseOnly: true,
    },
    component: () => import('@/pages/BuyerPages/enterprise/b_EmployeesGrid')
};
